// The launchpad's button treatment: outlined in white on a transparent fill.
// The themed blue button disappears into the brand gradient behind it, so every
// button that sits on the gradient (the bookmarks "Ok", the mobile "Close")
// shares this instead of each rolling its own overrides.
const dashboardButtonSx = {
  color: "#FFFFFF",
  borderColor: "#FFFFFF",
  backgroundColor: "transparent",
  boxShadow: "none",
  "&:hover": {
    borderColor: "#FFFFFF",
    backgroundColor: "rgba(255, 255, 255, 0.12)",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    color: "rgba(255, 255, 255, 0.5)",
    borderColor: "rgba(255, 255, 255, 0.5)",
  },
};

export default dashboardButtonSx;
